import { gql } from '@apollo/client';

export const SET_PPV_AUTO_FREE_SETTING = gql`
  mutation SetPpvAutoFreeSetting($input: SetPpvAutoFreeInput!) {
    setPpvAutoFreeSetting(input: $input) {
      isEnabled
      hours
    }
  }
`;

export const REVERT_AUTO_FREED_PPV_STREAMS = gql`
  mutation RevertAutoFreedPpvStreams {
    revertAutoFreedPpvStreams
  }
`;
